import request from 'utils/request'

const objectToFormData = (obj) => Object.entries(obj)
  .reduce((acc, [k, v]) => {
    acc.append(k, v)
    return acc
  }, new URLSearchParams()).toString()

const sendFormData = async (formValues) => request('/', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  body: objectToFormData(formValues)
}).then((v) => v.text())

export default sendFormData
